import React, { useState, useEffect, useRef } from 'react';
import CloseModal from '../../CloseModal';
import { connect } from "react-redux";
import * as actions from "redux/actions/commentActions";
import { Translate } from "react-redux-i18n";
import { EllipsisH } from "theme/icon";
import { openStockAnalysis } from 'utils/portfolioNav';

const ActionBtnRight = (props) => {
    const [openMenu, setOpenMenu] = useState(false);
    const [modalClose, setModalClose] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpenMenu(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, []);

    const handleToggleMenu = (event) => {
        event.stopPropagation();
        setOpenMenu((prev) => !prev);
    };

    const onClickClose = (event) => {
        event.stopPropagation();
        setOpenMenu(false);
        setModalClose(true);
    };

    const onClickAnalysis = (event) => {
        event.stopPropagation();
        setOpenMenu(false);
        const symbol = props.symbol || props.item?.symbol;
        if (props.item?.id != null || symbol) {
            openStockAnalysis(props.item?.id, symbol);
        }
    };

    const onClickDelete = (event) => {
        event.stopPropagation();
        setOpenMenu(false);
        props.delete();
    };

    const onClickCloseModalClose = () => {
        setModalClose(false);
    };

    return (
        <div ref={rootRef} style={{ position: 'relative', display: 'inline-block' }}>
            <span
                className="icon-button"
                style={{
                    padding: '3px',
                    background: 'gray',
                    borderRadius: '50%',
                }}
                onClick={handleToggleMenu}
                role="button"
                tabIndex={0}
                aria-haspopup="true"
                aria-expanded={openMenu}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleToggleMenu(event);
                    }
                }}
            >
                <EllipsisH />
            </span>
            {openMenu && (
                <ul
                    className="list portfolio-action-menu"
                    style={{
                        background: '#1b3745',
                        position: 'absolute',
                        right: 0,
                        top: '100%',
                        zIndex: 100,
                        margin: 0,
                        padding: 0,
                        listStyle: 'none',
                        minWidth: 120,
                    }}
                >
                    <li
                        className="list-item"
                        onClick={onClickClose}
                        style={{ width: '100%', paddingInline: '8px', cursor: 'pointer' }}
                    >
                        <Translate value="close" />
                    </li>
                    <li
                        className="list-item"
                        onClick={onClickAnalysis}
                        style={{ width: '100%', paddingInline: '8px', cursor: 'pointer' }}
                    >
                        <Translate value="option_menu_analysis" />
                    </li>
                    <li
                        className="list-item"
                        onClick={onClickDelete}
                        style={{ width: '100%', paddingInline: '8px', cursor: 'pointer' }}
                    >
                        <Translate value="delete" />
                    </li>
                </ul>
            )}
            {modalClose && (
                <CloseModal
                    item={props.item}
                    key={`close-${props.item?.id || props.item?.symbol}`}
                    price={props.price}
                    symbol={props.symbol}
                    parentCounter={props.parentCounter}
                    isSubOrder={props.isSubOrder}
                    close={onClickCloseModalClose}
                />
            )}
        </div>
    );
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        user: reducer.session.auth,
    };
}

const mapDispatchToProps = dispatch => ({
    removeItem: (params, token) =>
        dispatch(actions.removeItem({ params, token })),
    reportItem: (params, token) =>
        dispatch(actions.reportItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionBtnRight);
